import { render, staticRenderFns } from "./BookingsAccordion.vue?vue&type=template&id=5c64209e&scoped=true"
import script from "./BookingsAccordion.vue?vue&type=script&lang=ts"
export * from "./BookingsAccordion.vue?vue&type=script&lang=ts"
import style0 from "./BookingsAccordion.vue?vue&type=style&index=0&id=5c64209e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c64209e",
  null
  
)

export default component.exports